import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { disableAllMenu, isActiveSosongFlowChartModal, isActiveSosongGuideModal } from 'modules/actions/statusMenu';
import { selectCategory } from 'modules/actions/selectCategory';
import { setLevel1List } from 'modules/actions/guideMap';
import { chatList } from 'modules/actions/chat';
import { disabledTabMoveButton, disabledTabMoveInput, fallbackTabMove} from 'helper/index';
import PropTypes from 'prop-types';
import './style.scss';

const SosongFlowChartGrid = ({level1Arr,level1DetailOpen, level2Arr, level2DetailOpen, level3Arr, level3DetailOpen, level4Arr,level4DetailOpen, level5Arr,execOnSendMsg, refresh, openCloseBtnClick,allOpenOrClose}) => {
  const msgTop = document.querySelectorAll('._customer_message_div');
  const selectSentence = useSelector(state => state.setCategory.btnCategory);
  const [underscoreLevel1, setUnderscoreLevel1] = useState(false);
  const [underscoreLevel2, setUnderscoreLevel2] = useState(false);
  const [underscoreLevel3, setUnderscoreLevel3] = useState(false);
  const [underscoreLevel4, setUnderscoreLevel4] = useState(false);
  const [underscoreLevel5, setUnderscoreLevel5] = useState(false);
  const obj = {fontSize : 18}
  // const targetSentence = selectSentence[0].sentence;
  // const isSelectedSentence = selectSentence.length > 0 ? true : false;
  const levelRefs = useRef([]);
  levelRefs.current = [];
  const level1Ref = useRef();
  const level2Ref = useRef();
  const level3Ref = useRef();
  const level4Ref = useRef();
  const level5Ref = useRef();

  const addToRefs= (el) => {
    levelRefs.current.push(el);
  }

  // useEffect(()=> {
  //   const dd = document.getElementsByTagName('details');
  //   const fn = function(e) {      
  //     if(e.keyCode === 32){
  //       e.stopPropagation();
  //     }
  //   };
  //   dd.onkeypress = fn;
  // },[])

  useLayoutEffect(() => {
    if(selectSentence?.length > 0) {
      levelRefs.current.forEach((el) => {
        if(el.innerText !== null && selectSentence[0].sentence === el.innerText) {
          el.style.textDecoration = 'underline';
          el.style.fontWeight = '600';
          el.id = 'targetScroll';
          const target = document.getElementById('targetScroll'); // 요소의 id 값이 target이라 가정
          const clientRect = target.getBoundingClientRect(); // DomRect 구하기 (각종 좌표값이 들어있는 객체)
          const relativeTop = clientRect.top; // Viewport의 시작지점을 기준으로한 상대좌표 Y 값.
          const scrolledTopLength = window.pageYOffset; // 스크롤된 길이
          const absoluteTop = scrolledTopLength + relativeTop; // 절대좌표
          document.getElementById('flowchart_scroll').scrollTo({
            top: absoluteTop - 30,
            behavior: "smooth",
          });
        }
      })
    }
  },[])

  const onKeyPressEvt = (sentence,e) => {
    if (e.key === 'Enter') {
      execOnSendMsg(sentence,e);
    }
  };

  const underscoreText = (targetRef, levelArr, sentence) => {
    levelArr?.forEach((levelContent) => {
      if(levelContent?.sentence === targetRef?.current?.textContent && sentence === levelContent?.sentence) {
        targetRef.current.style.textDecoration = 'underline';
        targetRef.current.style.fontWeight = '600';
      }
    })
  }

  
  return (
    <>
      {refresh && !openCloseBtnClick && <ul className="tree">
        {level1Arr.map(level1 => {
          if (level1.isContinueNode) {
            return (
              <li>
                <details open={level1.level1 === level1DetailOpen} onToggle={(e) => execOnSendMsg(level1.sentence,e)}>
                <summary onKeyPress={(e) => onKeyPressEvt(level1.sentence,e)}><div className='continueTag' onClick={(e) => execOnSendMsg(level1.sentence,e)} aria-label={level1.sentence + ' 바로가기'}>{level1.sentence}</div></summary>
                  <ul>
                    {level2Arr.map(level2 => {
                      if (level1.level1 === level2.level1 && level2.isContinueNode) {
                        return (
                          <li>
                            <details open={level2.level2 === level2DetailOpen}>
                            <summary onKeyPress={(e) => onKeyPressEvt(level2.sentence,e)}><div onClick={(e) => execOnSendMsg(level2.sentence,e)} aria-label={level2.sentence + ' 바로가기'}>{level2.sentence}</div></summary>
                              <ul>
                                {level3Arr.map(level3 => {
                                  if (level2.level1 === level3.level1 && level2.level2 === level3.level2 && level3.isContinueNode) {
                                    return (
                                      <li>
                                        <details open={level3.level3 === level3DetailOpen}>
                                        <summary onKeyPress={(e) => onKeyPressEvt(level3.sentence,e)}><div onClick={(e) => execOnSendMsg(level3.sentence,e)} aria-label={level3.sentence + ' 바로가기'}>{level3.sentence}</div></summary>
                                          <ul>
                                            {level4Arr.map(level4 => {
                                              if (
                                                level3.level1 === level4.level1 &&
                                                level3.level2 === level4.level2 &&
                                                level3.level3 === level4.level3 &&
                                                level4.isContinueNode
                                              ) {
                                                return (
                                                  <li>
                                                    <details open={level4.level4 === level4DetailOpen}>
                                                    <summary onKeyPress={(e) => onKeyPressEvt(level4.sentence,e)}><div onClick={(e) => execOnSendMsg(level4.sentence,e)} aria-label={level4.sentence + ' 바로가기'}>{level4.sentence}</div></summary>
                                                      <ul>
                                                        {level5Arr.map(level5 => {
                                                          if (
                                                            level4.level1 === level5.level1 &&
                                                            level4.level2 === level5.level2 &&
                                                            level4.level3 === level5.level3 &&
                                                            level4.level4 === level5.level4 &&
                                                            !level5.isContinueNode
                                                          ) {
                                                            return <li className='lastLiTag'><button type='button' className='lastLiBtn' onClick={(e) => execOnSendMsg(level5.sentence,e)} aria-label={level5.sentence + ' 바로가기'}>{level5.sentence}</button></li>
                                                          }
                                                          return '';
                                                        })}
                                                      </ul>
                                                    </details>
                                                  </li>
                                                );
                                              }
                                              if (
                                                level3.level1 === level4.level1 &&
                                                level3.level2 === level4.level2 &&
                                                level3.level3 === level4.level3 &&
                                                !level4.isContinueNode
                                              ) {
                                                return <li className='lastLiTag'><button type='button' className='lastLiBtn' onClick={(e) => execOnSendMsg(level4.sentence,e)} aria-label={level4.sentence + ' 바로가기'}>{level4.sentence}</button></li>;
                                              }
                                              return '';
                                            })}
                                          </ul>
                                        </details>
                                      </li>
                                    );
                                  }
                                  if (level2.level1 === level3.level1 && level2.level2 === level3.level2 && !level3.isContinueNode) {
                                    return <li className='lastLiTag'><button type='button' className='lastLiBtn' onClick={(e) => execOnSendMsg(level3.sentence,e)} aria-label={level3.sentence + ' 바로가기'}>{level3.sentence}</button></li>;
                                  }
                                  return '';
                                })}
                              </ul>
                            </details>
                          </li>
                        );
                      }
                      if (level1.level1 === level2.level1 && !level2.isContinueNode) {
                        return <li className='lastLiTag' style={{textIndent : '-0.7em', marginTop: '3px', marginBottom: '5px'}}><button type='button' className='lastLiBtn' onClick={(e) => execOnSendMsg(level2.sentence,e)} aria-label={level2.sentence + ' 바로가기'}>{level2.sentence}</button></li>;
                      }
                      return '';
                    })}
                  </ul>
                </details>
              </li>
            );
          }
          return (
            <li>
              <ul>
              <li className='lastLiTag'><button type='button' className='lastLiBtn' onClick={(e) => execOnSendMsg(level1.sentence,e)} aria-label={level1.sentence + ' 바로가기'}>{level1.sentence}</button></li>
              </ul>
            </li>
          );
        })}
      </ul>}
      {refresh && openCloseBtnClick && <ul className="tree">
        {level1Arr.map(level1 => {
          if (level1.isContinueNode) {
            return (
              <li>
                <details aria-live='assertive' open={allOpenOrClose}>
                <summary onKeyPress={(e) => onKeyPressEvt(level1.sentence,e)}><div aria-label={level1.sentence + ' 바로가기'} className='continueTag' ref={addToRefs} onClick={(e) => execOnSendMsg(level1.sentence,e)}>{level1.sentence}</div></summary>
                  <ul>
                    {level2Arr.map(level2 => {
                      if (level1.level1 === level2.level1 && level2.isContinueNode) {
                        return (
                          <li>
                            <details open={allOpenOrClose}>
                            <summary onKeyPress={(e) => onKeyPressEvt(level2.sentence,e)}><div ref={addToRefs} onClick={(e) => execOnSendMsg(level2.sentence,e)} aria-label={level2.sentence + ' 바로가기'}>{level2.sentence}</div></summary>
                              <ul>
                                {level3Arr.map(level3 => {
                                  if (level2.level1 === level3.level1 && level2.level2 === level3.level2 && level3.isContinueNode) {
                                    return (
                                      <li>
                                        <details open={allOpenOrClose}>
                                        <summary onKeyPress={(e) => onKeyPressEvt(level3.sentence,e)}><div ref={addToRefs} onClick={(e) => execOnSendMsg(level3.sentence,e)} aria-label={level3.sentence + ' 바로가기'}>{level3.sentence}</div></summary>
                                          <ul>
                                            {level4Arr.map(level4 => {
                                              if (
                                                level3.level1 === level4.level1 &&
                                                level3.level2 === level4.level2 &&
                                                level3.level3 === level4.level3 &&
                                                level4.isContinueNode
                                              ) {
                                                return (
                                                  <li>
                                                    <details open={allOpenOrClose}>
                                                    <summary onKeyPress={(e) => onKeyPressEvt(level4.sentence,e)}><div ref={addToRefs} onClick={(e) => execOnSendMsg(level4.sentence,e)} aria-label={level4.sentence + ' 바로가기'}>{level4.sentence}</div></summary>
                                                      <ul>
                                                        {level5Arr.map(level5 => {
                                                          if (
                                                            level4.level1 === level5.level1 &&
                                                            level4.level2 === level5.level2 &&
                                                            level4.level3 === level5.level3 &&
                                                            level4.level4 === level5.level4 &&
                                                            !level5.isContinueNode
                                                          ) {
                                                            return <li className='lastLiTag'><button type='button' ref={addToRefs} className='lastLiBtn' onClick={(e) => execOnSendMsg(level5.sentence,e)} aria-label={level5.sentence + ' 바로가기'}>{level5.sentence}</button></li>
                                                          }
                                                          return '';
                                                        })}
                                                      </ul>
                                                    </details>
                                                  </li>
                                                );
                                              }
                                              if (
                                                level3.level1 === level4.level1 &&
                                                level3.level2 === level4.level2 &&
                                                level3.level3 === level4.level3 &&
                                                !level4.isContinueNode
                                              ) {
                                                return <li className='lastLiTag'><button type='button' className='lastLiBtn' ref={addToRefs} onClick={(e) => execOnSendMsg(level4.sentence,e)} aria-label={level4.sentence + ' 바로가기'}>{level4.sentence}</button></li>;
                                              }
                                              return '';
                                            })}
                                          </ul>
                                        </details>
                                      </li>
                                    );
                                  }
                                  if (level2.level1 === level3.level1 && level2.level2 === level3.level2 && !level3.isContinueNode) {
                                    return <li className='lastLiTag'><button type='button' className='lastLiBtn' ref={addToRefs} onClick={(e) => execOnSendMsg(level3.sentence,e)} aria-label={level3.sentence + ' 바로가기'}>{level3.sentence}</button></li>;
                                  }
                                  return '';
                                })}
                              </ul>
                            </details>
                          </li>
                        );
                      }
                      if (level1.level1 === level2.level1 && !level2.isContinueNode) {
                        return <li className='lastLiTag' style={{textIndent : '-0.7em', marginTop: '3px', marginBottom: '5px'}}><button type='button' ref={addToRefs} className='lastLiBtn' onClick={(e) => execOnSendMsg(level2.sentence,e)} aria-label={level2.sentence + ' 바로가기'}>{level2.sentence}</button></li>;
                      }
                      return '';
                    })}
                  </ul>
                </details>
              </li>
            );
          }
          return (
            <li>
              <ul>
              <li className='lastLiTag'><button type='button' className='lastLiBtn' ref={addToRefs} onClick={(e) => execOnSendMsg(level1.sentence,e)} aria-label={level1.sentence + ' 바로가기'}>{level1.sentence}</button></li>
              </ul>
            </li>
          );
        })}
      </ul>}
      </>
  );
};

SosongFlowChartGrid.propTypes = {
  level1Arr:  PropTypes.array,
  level1DetailOpen: PropTypes.bool,
  level2Arr: PropTypes.array,
  level2DetailOpen: PropTypes.bool,
  level3Arr: PropTypes.array,
  level3DetailOpen: PropTypes.bool,
  level4Arr: PropTypes.array,
  level4DetailOpen: PropTypes.bool,
  level5Arr: PropTypes.array,
  execOnSendMsg: PropTypes.func,
  allOpenOrClose: PropTypes.bool,
  openCloseBtnClick: PropTypes.bool,
  refresh: PropTypes.bool,
  // selectSentence: PropTypes.object
};
SosongFlowChartGrid.defaultProps = {
  level1Arr: [],
  level2Arr: [],
  level3Arr: [],
  level4Arr: [],
  level5Arr: [],
  level1DetailOpen: undefined,
  level2DetailOpen: undefined,
  level3DetailOpen: undefined,
  level4DetailOpen: undefined,
  refresh: false,
  allOpenOrClose:true,
  execOnSendMsg: () => {},
  openCloseBtnClick: true,
  // selectSentence: {}
};

export default SosongFlowChartGrid;
